import React from "react";

interface ComponentHiddenStatusProps {
  render(isHidden: boolean, setIsHidden: (isHidden: boolean) => void): React.ReactElement;
}

const ComponentHiddenStatus: React.FC<ComponentHiddenStatusProps> = (props) => {
  const [isHidden, setHidden] = React.useState(false);

  const setIsHidden = (isHidden: boolean) => {
    setHidden(isHidden);
  };

  return props.render(isHidden, setIsHidden);
};

export default ComponentHiddenStatus;
